import { TooltipFn, TooltipPoint, Series, DataPoint } from '../../../interfaces/Charts';
import { TooltipProps } from '../tooltip';
import { useState } from 'react';

export function useTooltip<P = DataPoint>(tooltipFunction?: TooltipFn<P>) {
  const [tooltip, setTooltip] = useState<TooltipProps>({
    x: 0,
    y: 0,
    message: '',
    visible: false,
  });

  const showTooltip = (p: TooltipPoint<P>) => {
    if (tooltipFunction) {
      setTooltip({
        x: p.x,
        y: p.y,
        message: tooltipFunction(p.series.points[p.index], p.index, p.series),
        visible: true,
      });
    }
  };

  const hideTooltip = () => {
    if (tooltip.visible) {
      setTooltip({ ...tooltip, visible: false });
    }
  };

  return { showTooltip, hideTooltip, tooltip, setTooltip };
}
